export default "/presentation/resources/sap/ui/webcomponents/main/messagebundle_ca.6a38d82dabbc5c30.json"